import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _abd7d0a8 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _998909b8 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _4c123572 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _4300c012 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _044646d2 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _9a454002 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _1f086c7d = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _7e398bd0 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _b83ac8be = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _403a767c = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _974e4fd4 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _4a0add8c = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _22991617 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _788e934f = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _043d670c = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _61af5ce1 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _29224e52 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _d6db9eb8 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _d454fff8 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _47699efe = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _66372a3b = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _3f0cdaa2 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _3e13aa5e = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _3fb053a4 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _b3f643fe = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _6353f85f = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _51bdd2fd = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _095940ea = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _d727547c = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _b6621bea = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _6b2ccbde = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _257a8cd4 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _a3047650 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _29bb27e8 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _5d1be8b2 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _cfe82912 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _70f76567 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _07cd03a9 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _2d624829 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _fa2d4416 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _19f3482a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _540a5a43 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _059bca86 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0d2c58dc = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _5425133c = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _15bd0f54 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _2a68aa44 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _0e0a17d6 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _69fe22dd = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _76abd625 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _283a72cc = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _493554e8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5963f682 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _11a6d9b8 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _edfe5602 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _384c3300 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _2388fb36 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _3ef85ad0 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _242c36b4 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _341af2f2 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _00982dc6 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _5783ad04 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _5ce66862 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _40dc1514 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _6abb8d6f = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _7f6376f3 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _475718bf = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _4615db6e = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _2f49e7fe = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _edc5f5a0 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _6e97cf84 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _2b4a07f2 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _69707474 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _dee0cbbc = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _abd7d0a8,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _998909b8,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _4c123572,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _4300c012,
    name: "calendar"
  }, {
    path: "/customer",
    component: _044646d2,
    name: "customer"
  }, {
    path: "/details",
    component: _9a454002,
    name: "details"
  }, {
    path: "/goals",
    component: _1f086c7d,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _7e398bd0,
    name: "maisoku"
  }, {
    path: "/media",
    component: _b83ac8be,
    name: "media"
  }, {
    path: "/privacy",
    component: _403a767c,
    name: "privacy"
  }, {
    path: "/project",
    component: _974e4fd4,
    name: "project"
  }, {
    path: "/response",
    component: _4a0add8c,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _22991617,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _788e934f,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _043d670c,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _61af5ce1,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _29224e52,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _d6db9eb8,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _d454fff8,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _47699efe,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _66372a3b,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _3f0cdaa2,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _3e13aa5e,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _3fb053a4,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _b3f643fe,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _6353f85f,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _51bdd2fd,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _095940ea,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _d727547c,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _b6621bea,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _6b2ccbde,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _257a8cd4,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _a3047650,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _29bb27e8,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _5d1be8b2,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _cfe82912,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _70f76567,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _07cd03a9,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _2d624829,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _fa2d4416,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _19f3482a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _540a5a43,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _059bca86,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0d2c58dc,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _5425133c,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _15bd0f54,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _2a68aa44,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _0e0a17d6,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _69fe22dd,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _76abd625,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _283a72cc,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _493554e8,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _5963f682,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _11a6d9b8,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _edfe5602,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _384c3300,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _2388fb36,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _3ef85ad0,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _242c36b4,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _341af2f2,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _00982dc6,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _5783ad04,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _5ce66862,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _40dc1514,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _6abb8d6f,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _7f6376f3,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _475718bf,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _4615db6e,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _2f49e7fe,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _edc5f5a0,
    name: "property-property",
    children: [{
      path: "contact",
      component: _6e97cf84,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _2b4a07f2,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _69707474,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _dee0cbbc,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
